import {
  Skeleton as MantineSkeleton,
  SkeletonProps as MantineSkeletonProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './Skeleton.module.css';

export type SkeletonColor = 'default' | 'darker';

export interface SkeletonProps extends Omit<
  MantineSkeletonProps,
  'styles' | 'classNames' | 'style'
> {
  /** Color variant */
  color?: SkeletonColor;
  style?: {
    aspectRatio?: string;
  };
}

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ color = 'default', radius = 32, className, ...props }, ref) => {
    return (
      <MantineSkeleton
        ref={ref}
        unstyled
        className={[styles.root, className].filter(Boolean).join(' ')}
        radius={radius}
        data-color={color}
        {...props}
      />
    );
  }
);

Skeleton.displayName = 'Skeleton';
